<template>
  <div>
    <b-row>
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Create"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="First Name" :required="true">
              <input
                ref="first_name"
                type="text"
                @blur="$v.contributor.first_name.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.contributor.first_name.$error }"
                v-model="contributor.first_name"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.contributor.first_name.required"
              >
                Enter name
              </div>
            </form-group>

             <form-group label="Surname">
              <input
                class="form-control"
                v-model="contributor.surname"
              />
            </form-group>

             <form-group label="Nickname">
              <input
                class="form-control"
                v-model="contributor.nickname"
              />
            </form-group>

            <form-group label="Brought Forward Balance">
              <input
                type="number"
                class="form-control"
                v-model="contributor.brought_forward"
              />
            </form-group>

             <form-group label="Email">
              <input
                class="form-control"
                v-model="contributor.email"
              />
            </form-group>

             <form-group label="Phone Number">
            <input
                class="form-control"
                v-model="contributor.phone_number"
              />
            </form-group>

             <form-group label="ID Number">
              <input
                class="form-control"
                v-model="contributor.id_number"
              />
            </form-group>

            <form-group label="Note">
              <textarea-autosize
                class="form-control"
                v-model="contributor.note"
              />
            </form-group>

           <form-group label="Collector">
              <b-form-select 
               value-field="id"
               text-field="name"
              v-model="contributor.collector_user_id" :options="collectors"></b-form-select>
            </form-group>

            <form-group label="Default Payment Type" :required="true">
              <b-form-select 
              v-model="contributor.default_payment_type" :options="paymentTypes"></b-form-select>
            </form-group>

            <form-group label="Scheme" :required="true">
              <b-form-select 
               @blur="$v.contributor.scheme_id.$touch"
               :class="{ 'is-invalid': $v.contributor.scheme_id.$error }"
               value-field="id"
               text-field="name"
               @change="contributor.scheme_plan_id = null"
               v-model="contributor.scheme_id" :options="schemes"></b-form-select>
                <div
                class="invalid-feedback"
                v-if="!$v.contributor.scheme_id.required"
              >
                Select Scheme
              </div>
            </form-group>

             <form-group label="Scheme Plan" :required="true" v-if="contributor.scheme_id != null">
              <b-form-select 
               @blur="$v.contributor.scheme_plan_id.$touch"
               :class="{ 'is-invalid': $v.contributor.scheme_plan_id.$error }"
               value-field="id"
               text-field="name"
               v-model="contributor.scheme_plan_id" :options="schemes.filter(x => x.id == contributor.scheme_id)[0].plans"></b-form-select>
                <div
                class="invalid-feedback"
                v-if="!$v.contributor.scheme_plan_id.required"
              >
                Select Plan
              </div>
            </form-group>

           
            
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import contributorRepo from "@/api/repos/contributorRepo";
import contributionRepo from "@/api/repos/contributionRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup,
  },

  validations: {
    contributor: {
      first_name: {
        required,
      },
      scheme_id:{
        required
      },
      scheme_plan_id:{
        required
      }
    },
  },

  data() {
    return {
      contributor: {
        scheme_id:null,
        scheme_plan_id:null
      },
      schemes: [],
      collectors: [],
      loading: false,
      errors: null,
      submitStatus: null,
      paymentTypes:[]
    };
  },

  mounted() {
    this.$refs.first_name.focus();
    this.getSchemes();
    this.getPaymentTypes();
  },

  methods: {
     async getPaymentTypes(){
      try{
        let {data} = await contributionRepo.paymentTypes();
        data.payment_types.forEach(x => {
          this.paymentTypes.push({
            text:x,
            value:x
          })
        });

      }catch(e){
        console.log(e)
          
      }
     
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
        this.loading = false;
        this.$root.$bvToast.toast("Form Errors", {
          title: "Errors on form data",
          autoHideDelay: 3000,
          variant: "danger",
        });
      } else {
        try {
          await contributorRepo.create(this.contributor);
          this.$emit("contributorCreated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },

    async getSchemes() {
      try {
        let {data} = await contributorRepo.createGetData(this.contributor);
        this.schemes = data.schemes
        this.collectors = data.collectors
      } catch (error) {
        console.log(error);        
      } 
    },
  },
};
</script>

<style></style>
